const MAIN_FRAMES = {
  REPORT_ISSUANCE_HISTORY: 'Report Issuance History',
  EXPORT_PREDEFINED_REPORT: 'Export Predefined Report',
  PREDEFINED_REPORT_MODAL: 'Predefined Report Modal',
} as const;

export const PREDEFINED_REPORT_FRAME_NAMES = {
  REPORT_ISSUANCE_HISTORY: {
    REPORT_ISSUANCE_HISTORY_LIST: `${MAIN_FRAMES.REPORT_ISSUANCE_HISTORY}/Report Issuance History List`,
    DOWNLOAD: `${MAIN_FRAMES.REPORT_ISSUANCE_HISTORY}/Download`,
    FILTER: `${MAIN_FRAMES.REPORT_ISSUANCE_HISTORY}/Filter`,
  },
  EXPORT_PREDEFINED_REPORT: {
    EXPORT_PREDEFINED_REPORT_LIST: `${MAIN_FRAMES.EXPORT_PREDEFINED_REPORT}/Export Predefined Report List`,
    FILTER: `${MAIN_FRAMES.EXPORT_PREDEFINED_REPORT}/FILTER`,
    EXPORT: `${MAIN_FRAMES.EXPORT_PREDEFINED_REPORT}/Export`,
  },
  PREDEFINED_REPORT_MODAL: {
    SHARE_USER_LIST: `${MAIN_FRAMES.PREDEFINED_REPORT_MODAL}/Share User List`,
    EDIT_PERMISSION_USER_LIST: `${MAIN_FRAMES.PREDEFINED_REPORT_MODAL}/Edit Permission User List`,
    REPORT_HEADER_CONTENTS: `${MAIN_FRAMES.PREDEFINED_REPORT_MODAL}/Report Header Contents`,
    CHECK_DUPLICATE_REPORT_NAME: `${MAIN_FRAMES.PREDEFINED_REPORT_MODAL}/Check Duplicate Report Name`,
    INFORMATION_TARGET_LIST: `${MAIN_FRAMES.PREDEFINED_REPORT_MODAL}/Information Target List`,
    BLOCK_PREVIEW_SAMPLE_DATA: `${MAIN_FRAMES.PREDEFINED_REPORT_MODAL}/Block Preview Sample Data`,
    BLOCK_SETTINGS_TARGET_COLUMN: `${MAIN_FRAMES.PREDEFINED_REPORT_MODAL}/Block Settings Target Column`,
    BLOCK_SETTINGS_SAMPLE_DATA: `${MAIN_FRAMES.PREDEFINED_REPORT_MODAL}/Block Settings Sample Data`,
    CHECK_DUPLICATE_BLOCK_NAME: `${MAIN_FRAMES.PREDEFINED_REPORT_MODAL}/Check Duplicate Block Name`,
    CREATE_DATA_BLOCK: `${MAIN_FRAMES.PREDEFINED_REPORT_MODAL}/Create Data Block`,
    UPDATE_DATA_BLOCK: `${MAIN_FRAMES.PREDEFINED_REPORT_MODAL}/Update Data Block`,
    SAVE_BLOCK_CHECK_DUPLICATE: `${MAIN_FRAMES.PREDEFINED_REPORT_MODAL}/Save Block Check Duplicate`,
    STYLE_SETTINGS_TARGET_COLUMN: `${MAIN_FRAMES.PREDEFINED_REPORT_MODAL}/Style Settings Target Column`,
    STYLE_SETTINGS_SAMPLE_DATA: `${MAIN_FRAMES.PREDEFINED_REPORT_MODAL}/Style Settings Sample Data`,
  },
} as const;
